export default "__VITE_ASSET__C32rSAzg__"